import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const StartChatButton = ({ userId, variant = "outline", label = "Message", className = "", testid = "start-chat-button" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!userId || (user && user.id === userId)) return null;
  return (
    <Button variant={variant} onClick={() => navigate(user ? `/messages/${userId}` : "/login")} className={`rounded-full ${className}`} data-testid={testid}>
      <MessageSquare className={`h-4 w-4 ${label ? "mr-1.5" : ""}`} /> {label}
    </Button>
  );
};
